export default () => ({
  accordion: {
    marginBottom: "8px",
  },
  accordionContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  executionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "16px",
  },
  executionRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "16px",
  },
  radioLabel: {
    marginRight: "16px",
    minWidth: "100px",
  },
  amiInput: {
    maxWidth: "400px",
  },
  hostNamesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  hostNameRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  hostNameInput: {
    width: "400px",
  },
  addHostButton: {
    alignSelf: "flex-start",
  },
  outputGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    marginTop: "16px",
  },
  logsKeeperConfig: {
    marginTop: "24px",
  },
  logsKeeperInputs: {
    display: "flex",
    gap: "16px",
    marginTop: "16px",
  },
  logsKeeperInput: {
    width: "200px",
  },
});
